<section
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="!error || pending || productsLoaded"
  id="nspActivationInternetContainer"
>
  <mprd-nsp-activation-skeleton
    *ngIf="!productsLoaded || mobileProductCount === -1"
  ></mprd-nsp-activation-skeleton>
  <main id="maincontent" role="main" *ngIf="productsLoaded && mobileProductCount !== -1">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-txt-c2 rs-has-subtit" data-cy="nspActivationInternetTitle">
            {{ 'nsp.activationInternet.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix" *ngIf="!error">
            <h2 class="rs-tit3">{{ subtitleKey | translate }}</h2>
            <p
              data-cy="nspActivationInternetDescription"
              [innerHTML]="'nsp.activationInternet.description' | translate"
            ></p>
            <mprd-nsp-internet-list-component
              [products]="internetProducts"
              data-cy="nspActivationInternetList"
            ></mprd-nsp-internet-list-component>
            <div class="rs-me"></div>
            <a
              href="javascript:void(0)"
              (click)="goToNextStep()"
              class="rs-btn"
              data-tms-event="button-click"
              data-tms-button-zone="nsp"
              [attr.data-tms-button-name]="getTaggingButtonName()"
              data-cy="nspActivationInternetContinueButton"
            >
              {{ 'nsp.activationInternet.button.continue' | translate }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
